/* ==========================================================================
   STELBO — paginile de prezentare (contact, locatie, despre noi)
   --------------------------------------------------------------------------
   Doua lucruri, amandoua degradeaza curat fara JS:

   1. <stelbo-hours> — starea reala a programului. Marcheaza ziua curenta si
      spune "Deschis acum", "Se inchide in curand" sau cand redeschidem.
   2. Dezvaluirea la derulare — clasa `.st-reveal-ready` se pune pe <html>
      DOAR de aici, iar CSS-ul ascunde elementele numai daca clasa exista.
      Daca scriptul nu se incarca, pagina e vizibila, nu goala.

   De ce nu `new Date()` simplu la program: ora vizitatorului nu spune nimic
   despre magazin. Cineva care deschide pagina din Spania la 19:30 ora locala
   ar vedea "Inchis" desi la Galati e 18:30 si magazinul e deschis. Ora se
   citeste in Europe/Bucharest prin Intl, care se ocupa si de ora de vara.
   ========================================================================== */

(function () {
  'use strict';

  /* Scriptul e declarat de mai multe sectiuni; pe o pagina cu doua dintre
     ele, browserul l-ar executa de doua ori. */
  if (window.__stelboPages) return;
  window.__stelboPages = true;

  var TZ = 'Europe/Bucharest';

  /* Numele zilelor, indexate ca in JS: 0 = duminica. */
  var DAY_NAMES = [
    'duminică',
    'luni',
    'marți',
    'miercuri',
    'joi',
    'vineri',
    'sâmbătă'
  ];

  /* ------------------------------------------------------------------------
     Ora din Galati, ca minute de la miezul nopții + ziua saptamanii.

     `formatToParts` cu locale 'en-US' si `hour12: false` da componentele
     numerice, indiferent de setarile browserului. Din ele reconstruiesc un
     Date in UTC si citesc `getUTCDay()` — asa ziua saptamanii e cea de la
     Galati, nu cea locala. (Ora 24 apare in unele implementari pentru
     miezul nopții; e adusa la 0.)
     ------------------------------------------------------------------------ */
  function shopNow() {
    var parts;

    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return null;
    }

    var v = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') v[parts[i].type] = parseInt(parts[i].value, 10);
    }

    if (isNaN(v.year) || isNaN(v.hour) || isNaN(v.minute)) return null;
    if (v.hour === 24) v.hour = 0;

    var stamp = new Date(Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute));

    return {
      day: stamp.getUTCDay(),
      minutes: v.hour * 60 + v.minute
    };
  }

  function hhmm(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  }

  /* ------------------------------------------------------------------------
     <stelbo-hours data-hours='[{"day":1,"open":540,"close":1140}, ...]'>
     ------------------------------------------------------------------------ */
  function initHours(root) {
    var schedule;

    try {
      schedule = JSON.parse(root.getAttribute('data-hours') || '[]');
    } catch (e) {
      return;
    }

    if (!schedule.length) return;

    var now = shopNow();
    if (!now) return;

    /* Program indexat pe zi, ca sa pot cauta inainte fara sa parcurg lista. */
    var byDay = {};
    for (var i = 0; i < schedule.length; i++) {
      var entry = schedule[i];
      if (typeof entry.open === 'number' && typeof entry.close === 'number' && entry.close > entry.open) {
        byDay[entry.day] = entry;
      }
    }

    /* --- Ziua curenta, marcata in tabel --- */
    var rows = root.querySelectorAll('[data-day]');
    for (var r = 0; r < rows.length; r++) {
      var rowDay = parseInt(rows[r].getAttribute('data-day'), 10);
      if (rowDay !== now.day) continue;

      rows[r].setAttribute('data-today', '');

      /* Cursorul "acum" pe bara de azi, doar cat timp bara e vizibila
         (pe telefon barele sunt ascunse din CSS, deci nu il adaug). */
      var track = rows[r].querySelector('[data-track]');
      if (track && !track.querySelector('.stelbo-hours__now')) {
        var cursor = document.createElement('span');
        cursor.className = 'stelbo-hours__now';
        cursor.style.setProperty('--st-h-now', ((now.minutes / 1440) * 100).toFixed(2) + '%');
        track.appendChild(cursor);
      }
    }

    /* --- Starea --- */
    var today = byDay[now.day];
    var state = 'closed';
    var text;

    if (today && now.minutes >= today.open && now.minutes < today.close) {
      var left = today.close - now.minutes;
      if (left <= 60) {
        state = 'closing';
        text = 'Se închide în ' + left + ' min · la ' + hhmm(today.close);
      } else {
        state = 'open';
        text = 'Deschis acum · până la ' + hhmm(today.close);
      }
    } else if (today && now.minutes < today.open) {
      text = 'Închis · deschidem azi la ' + hhmm(today.open);
    } else {
      /* Urmatoarea zi cu program, in maximum o saptamana. */
      for (var step = 1; step <= 7; step++) {
        var day = (now.day + step) % 7;
        if (!byDay[day]) continue;
        text =
          'Închis · deschidem ' +
          (step === 1 ? 'mâine' : DAY_NAMES[day]) +
          ' la ' +
          hhmm(byDay[day].open);
        break;
      }
    }

    if (!text) return;

    var label = root.querySelector('[data-state-text]');
    if (!label) return;

    label.textContent = text;
    root.setAttribute('data-state', state);

    var pill = root.querySelector('[data-state-pill]');
    if (pill) pill.hidden = false;
  }

  /* ------------------------------------------------------------------------
     Dezvaluirea la derulare
     ------------------------------------------------------------------------ */
  function initReveal() {
    var targets = document.querySelectorAll('[data-st-reveal]');
    if (!targets.length) return;

    /* Fara IntersectionObserver sau cu miscare redusa: nu ascund nimic. */
    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    document.documentElement.classList.add('st-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          entries[i].target.classList.add('is-in');
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var t = 0; t < targets.length; t++) observer.observe(targets[t]);
  }

  function boot() {
    var panels = document.querySelectorAll('stelbo-hours');
    for (var i = 0; i < panels.length; i++) initHours(panels[i]);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-randarea unei sectiuni inlocuieste marcajul, deci
     marcajul zilei si pastila de stare trebuie puse din nou. */
  document.addEventListener('shopify:section:load', function (event) {
    var panels = event.target.querySelectorAll('stelbo-hours');
    for (var i = 0; i < panels.length; i++) initHours(panels[i]);

    var targets = event.target.querySelectorAll('[data-st-reveal]');
    for (var t = 0; t < targets.length; t++) targets[t].classList.add('is-in');
  });
})();
